var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52926 8.85355C8.72452 9.04881 9.0411 9.04881 9.23637 8.85355C9.43163 8.65829 9.43163 8.34171 9.23637 8.14645L5.58992 4.5L9.23636 0.853554C9.43163 0.658292 9.43163 0.341709 9.23636 0.146447C9.0411 -0.0488152 8.72452 -0.0488152 8.52926 0.146447L4.88281 3.79289L1.23637 0.146447C1.0411 -0.0488155 0.724523 -0.0488155 0.529261 0.146447C0.333998 0.341709 0.333998 0.658291 0.529261 0.853553L4.17571 4.5L0.529259 8.14645C0.333997 8.34171 0.333997 8.65829 0.529259 8.85355C0.724521 9.04881 1.0411 9.04881 1.23637 8.85355L4.88281 5.20711L8.52926 8.85355Z",
    fill: "#1E2228"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.da974da23c3e4f5946b6ac1a022ea419.svg";
export { ForwardRef as ReactComponent };